import React from "react";
import { Tile } from "./Tile";
import "./Tile.css";

export function KpiTile({
  label,
  value,
  trendValue,
  trendLabel,
  trendTone = "neutral",
}) {
  return (
    <Tile>
      <div className="ss-kpi">
        <div className="ss-kpi__label">{label}</div>
        <div className="ss-kpi__row">
          <div className="ss-kpi__value">{value}</div>
          {(trendValue || trendLabel) && (
            <div className={`ss-trend ss-trend--${trendTone}`}>
              {trendValue && <span className="ss-trend__value">{trendValue}</span>}
              {trendLabel && <span className="ss-trend__label">{trendLabel}</span>}
            </div>
          )}
        </div>
      </div>
    </Tile>
  );
}